import { UIOpacity, Node, Tween, tween } from 'cc';

namespace TweenUtils {
    export function fadeIn(
        target: Node | UIOpacity,
        duration: number,
        reset = false,
        adjustActive = true,
        easing: (number: number) => number = null,
    ): Tween<UIOpacity> {
        if (!target) {
            return null;
        }
        if (!target.isValid) {
            return null;
        }
        let temp: UIOpacity = target instanceof Node ? target.getComponent(UIOpacity) : target;
        if (!temp) {
            temp = target.addComponent(UIOpacity);
        }
        if (adjustActive) {
            temp.node.active = true;
        }
        if (reset) {
            temp.opacity = 0;
        }
        Tween.stopAllByTarget(temp);
        return tween(temp).to(
            duration,
            { opacity: 255 },
            {
                easing: easing ?? ((t) => t),
            },
        );
    }

    export function fadeOut(
        target: Node | UIOpacity,
        duration: number,
        reset = false,
        adjustActive = true,
        easing: (number) => number = null,
    ): Tween<UIOpacity> {
        if (!target) {
            return null;
        }
        if (!target.isValid) {
            return null;
        }
        let temp: UIOpacity = target instanceof Node ? target.getComponent(UIOpacity) : target;
        if (!temp) {
            temp = target.addComponent(UIOpacity);
        }
        if (reset) {
            temp.opacity = 255;
        }
        Tween.stopAllByTarget(temp);
        return tween(temp)
            .to(
                duration,
                { opacity: 0 },
                {
                    easing: easing ?? ((t) => t),
                },
            )
            .call(() => {
                if (adjustActive) {
                    temp.node.active = false;
                }
            });
    }

    export function fadeInOut(target: Node | UIOpacity, fadeDuration: number, stayDuration: number, reset = false): Tween<UIOpacity> {
        if (!target) {
            return null;
        }
        if (!target.isValid) {
            return null;
        }
        const temp: UIOpacity = target instanceof Node ? target.getComponent(UIOpacity) : target;
        if (!temp) {
            return null;
        }
        temp.node.active = true;
        if (reset) {
            temp.opacity = 0;
        }
        Tween.stopAllByTarget(temp);
        return tween(temp)
            .to(fadeDuration, { opacity: 255 })
            .delay(stayDuration)
            .to(fadeDuration, { opacity: 0 })
            .call(() => {
                temp.node.active = false;
            });
    }
}

export default TweenUtils;
